import { render, staticRenderFns } from "./custom-landing-dc.vue?vue&type=template&id=0a0d72a0&"
import script from "./custom-landing-dc.vue?vue&type=script&lang=js&"
export * from "./custom-landing-dc.vue?vue&type=script&lang=js&"
import style0 from "./custom-landing-dc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports